import { useState } from "react";
import apiJurados from "../api/Jurados/api-jurados";
import apiMaestras from "../api/Maestras/api-maestras";

export const useBancoJurado = () => {
  const [jurados, setJurados] = useState([]);
  const [preJurados, setPreJurados] = useState([]);
  const [totalbancoJurados, setTotalbancoJurados] = useState(0);
  const [totalInscritosSinRevisar, setTotalInscritosSinRevisar] = useState(0);
  const [totalSubsanar, setTotalSubsanar] = useState(0);
  const [totalSubsanado, setTotalSubsanado] = useState(0);
  const [totalEnEstudio, setTotalEnEstudio] = useState(0);
  const [totalRechazado, setTotalRechazado] = useState(0);
  const [totalPostulaciones, setTotalPostulaciones] = useState(0);
  const [loadingJurados, setLoadingJurados] = useState(false);
  const [areas, setAreas] = useState<any[]>([]);

  const [filtros, setFiltros] = useState<any>({
    palabra_clave: "",
    area: null,
    categoria: null,
    estado: null,
  });

  const buscarPorPalabraClave = async (arr: any[]): Promise<any[]> => {
    if (filtros.palabra_clave === "") return arr;
    const resp = /^\d+$/.test(filtros.palabra_clave)
      ? await apiJurados.obetenerJuradoDoc(filtros.palabra_clave)
      : await apiJurados.obetenerJuradoRadicado(filtros.palabra_clave.toUpperCase());
    if (resp && Array.isArray(resp.juries)) return resp.juries;
    if (Array.isArray(resp)) return resp;
    return [];
  };

  const radicadoNum = (x: any): number => {
    try {
      const part = x.radicado ? String(x.radicado).split("-")[1] : undefined;
      const n = part ? parseInt(part, 10) : NaN;
      return isNaN(n) ? 0 : n;
    } catch { return 0; }
  };

  const buscarFiltros = async () => {
    setLoadingJurados(true);
    let arrFiltro = await buscarPorPalabraClave([...preJurados]);

    if (filtros.area !== null) {
      const areaSeleccionada = areas.find((a: any) => a.id_area === filtros.area);
      const areaNombre = (areaSeleccionada?.nombre_area ?? "").toUpperCase();
      if (areaNombre) {
        arrFiltro = arrFiltro.filter((x: any) => (x.area ?? "").toUpperCase() === areaNombre);
      } else {
        arrFiltro = arrFiltro.filter((x: any) => x.area === filtros.area);
      }
    }

    if (filtros.categoria !== null) {
      arrFiltro = arrFiltro.filter((x: any) => {
        try {
          const ids = x.areas_conocimientos[0].areas_conocimientos.map((area: any) => area.id);
          return ids.includes(filtros.categoria);
        } catch { return false; }
      });
    }

    if (filtros.estado !== null) {
      arrFiltro = arrFiltro.filter((x: any) => x.status === filtros.estado);
    }

    arrFiltro = arrFiltro.sort((a: any, b: any) => radicadoNum(a) - radicadoNum(b));

    setTotalbancoJurados(arrFiltro.length);
    actualizarContadores(arrFiltro);
    setJurados(arrFiltro as any);
    setLoadingJurados(false);
  };

  const actualizarContadores = (lista: any[]) => {
    setTotalInscritosSinRevisar(lista.filter((x: any) => x.status === "Sin verificar").length);
    setTotalSubsanar(lista.filter((x: any) => x.status === "Subsanar").length);
    setTotalSubsanado(lista.filter((x: any) => x.status === "Subsanado").length);
    setTotalEnEstudio(lista.filter((x: any) => x.status === "Aceptó").length);
    setTotalRechazado(lista.filter((x: any) => x.status === "Rechazado").length);
  };

  const [categorias, setCategorias] = useState<any[]>([]);


  const obtenerAreas = async () => {
    try {
      const data: any = await apiMaestras.obtenerAreasConCategorias();
      // La respuesta tiene forma: { ok: true, areas: [...] }
      let lista: any[];
      if (Array.isArray(data?.areas)) { lista = data.areas; }
      else if (Array.isArray(data)) { lista = data; }
      else { lista = []; }
      setAreas(lista);
    } catch (error) {
      console.error("Error al obtener áreas:", error);
    }
  };

  // Al cambiar área, extrae las categorías desde los datos ya cargados
  const handleAreaChange = (id_area: any) => {
    setFiltros((prev: any) => ({ ...prev, area: id_area, categoria: null }));
    setCategorias([]);

    // Estructura: { id_area, nombre_area, categorias_areas: [{id, nombre}] }
    const areaData = areas.find((a: any) => a.id_area === id_area);
    if (areaData && Array.isArray(areaData.categorias_areas)) {
      setCategorias(areaData.categorias_areas);
    }
  };

  const limpiarFiltros = (tipo: string) => {
    setTotalInscritosSinRevisar(0);
    setTotalSubsanar(0);
    setTotalSubsanado(0);
    setTotalEnEstudio(0);
    setTotalRechazado(0);
    setFiltros({
      palabra_clave: "",
      area: null,
      categoria: null,
      estado: null,
    });
  };

  const obtenerJurados = async (tipo?: string) => {
    setLoadingJurados(true);
    try {
      const jurados = await apiJurados.getJurados();

      switch (tipo) {
        case "gestionEvaluador":
          let gestionEvaluador = jurados.filter(
            (x: any) =>
              [
                "Sin verificar",
                "No cumple",
                "Postulado",
                "Aceptó",
                "Aceptado",
              ].includes(x.status)
          );

          let gestion = gestionEvaluador.map(function (jurado: any) {
            if (jurado.status == "Aceptó") {
              jurado.status = "Postulado";
            }
            return jurado;
          });

          setPreJurados(gestion);
          setJurados(gestion);
          break;

        case "bancojurados":
          console.log('jurados =====', jurados)
          let bancoJurados = jurados.filter((x: any) =>
            [
              "Sin verificar",
              "Postulado",
              "Subsanar",
              "Subsanado",
              "Rechazado",
              "Anulado",
              "Aceptado",
              "Aceptó"
            ].includes(x.status)
          );

          bancoJurados.length > 0
            ? setTotalbancoJurados(bancoJurados.length)
            : setTotalbancoJurados(0);
          setPreJurados(bancoJurados);
          setJurados(bancoJurados);
          actualizarContadores(bancoJurados);
          break;

        case "postulaciones":
          let postulaciones = jurados.filter((x: any) =>
            ["Postulado", "Aceptó", "No aceptó", "No responde"].includes(x.status)
          );

          postulaciones.length > 0
            ? setTotalPostulaciones(postulaciones.length)
            : setTotalPostulaciones(0);
          setPreJurados(postulaciones);
          setJurados(postulaciones);
          actualizarContadores(postulaciones);
          break;

        default:
          setPreJurados(jurados);
          setJurados(jurados);
          actualizarContadores(jurados);
          break;
      }

      setLoadingJurados(false);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    obtenerJurados,
    jurados,
    totalBancoJurados: totalbancoJurados,
    totalInscritosSinRevisar,
    totalSubsanar,
    totalSubsanado,
    totalEnEstudio,
    totalRechazado,
    totalPostulacions: totalPostulaciones,
    loadingJurados,
    handleAreaChange,
    categorias,
    setCategorias,
    filtros,
    setFiltros,
    buscarFiltros,
    limpiarFiltros,
    obtenerAreas,
    areas
  };
};
